export default "__VITE_ASSET__C_3bAT7a__"